// RAPIFAST :: Página pública de consulta de documentos legales (borradores del piloto).
// Renderiza la transcripción fiel de los borradores del usuario (lib/legalDocs.js).
import { Link } from "react-router-dom";
import { ArrowLeft, FileWarning, Mail } from "lucide-react";
import { LogoFull } from "@/components/Logo";
import { LEGAL_BANNER, OPERADOR_PENDIENTE, TERMINOS, PRIVACIDAD } from "@/lib/legalDocs";

const DOCS = { terminos: TERMINOS, privacidad: PRIVACIDAD };

export default function LegalDocPage({ doc }) {
  const d = DOCS[doc] || TERMINOS;
  return (
    <div className="min-h-screen bg-[#0B0B0B] px-5 py-8 text-gray-300" data-testid={`legal-page-${doc}`}>
      <div className="mx-auto w-full max-w-2xl">
        <div className="flex justify-center">
          <LogoFull className="h-16 w-auto sm:h-20" />
        </div>

        <Link to="/auth" className="mb-5 mt-3 inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-white"
          data-testid="legal-back-link">
          <ArrowLeft size={15} /> Volver
        </Link>

        <div className="mb-5 rounded-2xl border-2 border-amber-500/60 bg-amber-500/10 px-4 py-3" data-testid="legal-draft-banner">
          <div className="flex items-start gap-2.5">
            <FileWarning size={18} className="mt-0.5 shrink-0 text-amber-400" />
            <div>
              <div className="font-heading text-sm font-extrabold tracking-wide text-amber-400">{LEGAL_BANNER}</div>
              <p className="mt-1 text-xs text-amber-200/80">
                Este texto organiza la propuesta actual de RAPIFAST. No es asesoría jurídica ni un documento
                contractual vigente. {d.version}.
              </p>
            </div>
          </div>
        </div>

        <h1 className="font-heading text-2xl font-extrabold text-white sm:text-3xl" data-testid="legal-doc-title">
          {d.title}
        </h1>
        <p className="mt-3 rounded-xl border border-[#27272A] bg-[#0d0d0f] px-4 py-3 text-sm leading-relaxed text-gray-400">
          {d.intro}
        </p>

        <div className="mt-5 rounded-2xl border border-[#27272A] bg-[#101012] p-4" data-testid="legal-operator-block">
          <h2 className="font-heading text-sm font-bold text-white">Identificación del operador de la plataforma</h2>
          <dl className="mt-2 space-y-1.5">
            {OPERADOR_PENDIENTE.map(([k, v]) => (
              <div key={k} className="flex flex-wrap items-baseline gap-2 text-xs">
                <dt className="font-semibold text-gray-400">{k}:</dt>
                <dd className={v.startsWith("Pendiente") ? "font-bold text-amber-400" : "text-gray-200"}
                  data-testid={`legal-operator-${k.slice(0, 12).replace(/\s/g, "-")}`}>
                  {v}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-6 space-y-5">
          {d.sections.map(([h, body]) => (
            <section key={h} data-testid={`legal-section-${h.split(".")[0]}`}>
              <h2 className="font-heading text-base font-bold text-white md:text-lg">{h}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-gray-400">{body}</p>
            </section>
          ))}
        </div>

        <div className="mt-6 rounded-2xl border border-[#27272A] bg-[#101012] p-4" data-testid="legal-pendings-block">
          <h2 className="font-heading text-sm font-bold text-white">Pendientes obligatorios antes de publicar</h2>
          <ul className="mt-2 list-disc space-y-1.5 pl-5 text-xs leading-relaxed text-gray-400">
            {d.pendientes.map((p) => <li key={p.slice(0, 30)}>{p}</li>)}
          </ul>
        </div>

        <div className="mt-6 mb-4 flex items-center gap-2 rounded-xl border border-[#27272A] bg-[#0d0d0f] px-4 py-3 text-xs text-gray-400">
          <Mail size={14} className="shrink-0 text-[#FF6A00]" />
          Contacto del piloto: <span className="font-semibold text-gray-200">servicioalcliente@rapifastapp.com</span>
        </div>
      </div>
    </div>
  );
}
